import moment from "moment";

const getPaymentDay = (frequency, firstPaymentDate) => {
  if (frequency === "Monthly") {
    return moment(firstPaymentDate, "MM/DD/YYYY").format("Do");
  }
  if (frequency === "Weekly") {
    return moment(firstPaymentDate, "MM/DD/YYYY").format("dddd");
  }
  if (frequency === "Bi-Weekly") {
    return "Every other " + moment(firstPaymentDate, "MM/DD/YYYY").format("dddd");
  }
};

export default getPaymentDay;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/get-payment-day.js